import {SELECT_TYPE} from './FileTypeResource';

export const documentFileTypeResource = [
    {
        name: SELECT_TYPE, value: SELECT_TYPE
    },
    {
        name: 'abw', value: 'abw'
    },
    {
        name: 'x-abiword', value: 'x-abiword'
    },
    {
        name: 'doc', value: 'doc'
    },
    {
        name: 'msword', value: 'msword'
    },
    {
        name: 'docx', value: 'docx'
    },
    {
        name: 'vnd.openxmlformats-officedocument.wordprocessingml.document',
        value: 'vnd.openxmlformats-officedocument.wordprocessingml.document'
    },
    {
        name: 'odt', value: 'odt'
    },
    {
        name: 'vnd.oasis.opendocument.text', value: 'vnd.oasis.opendocument.text'
    },
    {
        name: 'pdf', value: 'pdf'
    }
];